module.exports = __webpack_public_path__ + "img/icon-success.ac4ee080.svg";